<template>
    <div>
        <Dialog :has-backdrop="true" :show="show" @close="$emit('close')" :show-close-button="closeable">
            <h4 class="title">{{title}}</h4>
            <div class="body">
                <slot></slot>
            </div>
            <div class="footer">
                <AdaButton :key="refreshKey" :to="to" style="margin-right:10px" :title="defaultOptions.confirm.title"
                           type="dialogConfirm" :icon="defaultOptions.confirm.icon" @click="$emit('onok')" :loading="okLoading"></AdaButton>
                <AdaButton :key="refreshKey+2" :to="to" :title="defaultOptions.cancel.title" type="dialogCancel"
                           :icon="defaultOptions.cancel.icon" @click="$emit('oncancel')"></AdaButton>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "./Dialog";
    import AdaButton from "../buttons/AdaButton";

    export default {
        name: "Confirm",
        components: {AdaButton, Dialog},
        props: {
            show: Boolean,
            title: {
                type: String,
                default: 'Engagement Tool'
            },
            closeable: {
                type: Boolean,
                default: true
            },
            options: Object,
            to: String,
            refreshKey: [String, Number],
            okLoading: {
                type: Boolean,
                default:false
            },
            width:{

            }
        },
        computed: {
            defaultOptions: function () {
                let ret = {
                    confirm: {
                        title: 'Bestätigen',
                        icon: 'icon-apply'
                    },
                    cancel: {
                        title: 'Verwerfen',
                        icon: 'icon-delete'
                    }
                };

                if (this.options) {
                    for (let key in this.options) {
                        for (let subKey in this.options[key]) {
                            ret[key][subKey] = this.options[key][subKey];
                        }
                    }
                }
                return ret;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .title {
        margin-top: 0;
    }

    .body {
        padding-bottom: 60px;
    }

    .footer {
        display: flex;
        flex-flow: row;
        position: absolute;
        bottom: 1.5rem;
    }

    ::v-deep .modal-container {
        display: flex;
        flex-flow: column;

        .title {
            margin-bottom: 20px;
        }
    }
</style>